/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WarpQuayInner } from './WarpQuayInner';
import {
    WarpQuayInnerFromJSON,
    WarpQuayInnerFromJSONTyped,
    WarpQuayInnerToJSON,
} from './WarpQuayInner';

/**
 * Any information can be stored and retrieved. The parts used in the system are shown here.
 * @export
 * @interface Warp
 */
export interface Warp {
    /**
     * Optional identifier assigned by the ERP system
     * @type {number}
     * @memberof Warp
     */
    id?: number;
    /**
     * 
     * @type {Array<WarpQuayInner>}
     * @memberof Warp
     */
    quay?: Array<WarpQuayInner>;
    /**
     * 
     * @type {Array<number>}
     * @memberof Warp
     */
    bollards?: Array<number>;
    /**
     * Estimated Time of Arrival (ETA) in ISO Extended format
     * @type {string}
     * @memberof Warp
     */
    eta?: string;
    /**
     * Estimated Time of Departure (ETD) in ISO Extended format
     * @type {string}
     * @memberof Warp
     */
    etd?: string;
    /**
     * Optional indication of intended side to the berth. true = starboard, false = port and N/A = unknown
     * @type {boolean}
     * @memberof Warp
     */
    starboard?: boolean;
    /**
     * Color for arrival in hex format e.g. #00ff88
     * @type {string}
     * @memberof Warp
     */
    color?: string;
}

/**
 * Check if a given object implements the Warp interface.
 */
export function instanceOfWarp(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WarpFromJSON(json: any): Warp {
    return WarpFromJSONTyped(json, false);
}

export function WarpFromJSONTyped(json: any, ignoreDiscriminator: boolean): Warp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'quay': !exists(json, 'quay') ? undefined : ((json['quay'] as Array<any>).map(WarpQuayInnerFromJSON)),
        'bollards': !exists(json, 'bollards') ? undefined : json['bollards'],
        'eta': !exists(json, 'eta') ? undefined : json['eta'],
        'etd': !exists(json, 'etd') ? undefined : json['etd'],
        'starboard': !exists(json, 'starboard') ? undefined : json['starboard'],
        'color': !exists(json, 'color') ? undefined : json['color'],
    };
}

export function WarpToJSON(value?: Warp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'quay': value.quay === undefined ? undefined : ((value.quay as Array<any>).map(WarpQuayInnerToJSON)),
        'bollards': value.bollards,
        'eta': value.eta,
        'etd': value.etd,
        'starboard': value.starboard,
        'color': value.color,
    };
}

